var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"#888888","width":"100%","display":"inline-block"}},[(!_vm.question.isValid)?_c('span',{staticStyle:{"color":"red"}},[_vm._v(" "+_vm._s(_vm.question.errorMessage)+" ")]):_c('span',[_vm._v(_vm._s(_vm.question.valueString))]),(_vm.elementPrice !== 0)?_c('span',[_vm._v("($"+_vm._s(_vm.elementPrice)+")")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }